import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { buildCJALinkClick } from 'yoda-site-components/lib/analytics/CJAEventsHelper';

const legacyVersion = 'apollo 1 2017 redesign yoda post purchase';

const CJA_EVENT_MODULE_MAP = {
    selfReturnTrackLink: 'trackingnumber:selfReturnTrackLink',
    selfReturnTrackCTA: 'trackingnumber:selfReturnTrackCTA',
    'startonlinereturn:mp': 'mponlinereturn:start',
    'confirmreturn:mp': 'mponlinereturn:confirm',
    curbsideBottomSheetImpression: 'curbside:bottomsheetimpression',
    curbsideAssociateOnTheWay: 'curbside:associateontheway',
    curbsidePickedUp: 'curbside:pickedup',
    curbsideCancelCTA: 'curbside:cancelcta',
    curbsideCancelConfirmation: 'curbside:cancelconfirmation',
};

const trackCJAPageView = (pageName, pageType = 'account') => {
    const payload = buildCJAPageViewPayload(
        {
            name: pageName,
            type: pageType,
            siteSection: 'account',
            category: { primary: 'account' },
            tech: { version: legacyVersion },
        },
        {},
        { interactionName: 'regular_pageview' }
    );
    return { eventName: 'pageView', eventData: payload };
};

const trackCJALinkClickEvent = (eventName, data = {}) => {
    const baseModule = CJA_EVENT_MODULE_MAP[eventName];
    if (!baseModule) return null;

    const storeId = data.curbsideSelectedStoreID || '';
    const linkModuleName = storeId ? `${baseModule}:${storeId}` : baseModule;

    const { eventName: cjaEventName, payload } = buildCJALinkClick({ linkModuleName });
    return { eventName: cjaEventName, eventData: payload };
};

export { trackCJAPageView, trackCJALinkClickEvent };
